import { render, staticRenderFns } from "./ordenClinicaMedicamentoShow.vue?vue&type=template&id=b3ef06a0"
import script from "./ordenClinicaMedicamentoShow.vue?vue&type=script&lang=js"
export * from "./ordenClinicaMedicamentoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports